import { render, staticRenderFns } from "./edutalk-hierarchy.vue?vue&type=template&id=17e2c26c&scoped=true"
import script from "./edutalk-hierarchy.vue?vue&type=script&lang=js"
export * from "./edutalk-hierarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2c26c",
  null
  
)

export default component.exports